import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { TInterviewRelease, TReleaseVariables } from './releaseAndNotify';

import { notify, notifyMeta } from '@/lib/notify';
import { INTERVIEW_CALL_COPY } from '@/constants/interviewCall';
import { APPLICANT_KEYS, COUNTER_KEYS, INTERVIEW_KEYS } from '@/constants/queryKeys';

import { releaseAndNotify } from './releaseAndNotify';

const useReleaseInterview = () => {
  const queryClient = useQueryClient();

  return useMutation<TInterviewRelease, Error, TReleaseVariables>({
    meta: notifyMeta('interviewRelease'),
    mutationKey: ['interviews', 'release'],
    mutationFn: releaseAndNotify,
    onSuccess: async (outcome) => {
      if (outcome.calendly === 'failed') {
        notify.error(INTERVIEW_CALL_COPY.calendlyNotCanceled);
      }

      if (outcome.letter === 'failed') {
        notify.error(INTERVIEW_CALL_COPY.letterNotSent);
      }

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: APPLICANT_KEYS.root }),
        queryClient.invalidateQueries({ queryKey: INTERVIEW_KEYS.root }),
        queryClient.invalidateQueries({ queryKey: COUNTER_KEYS.root }),
      ]);
    },
  });
};

export {
  useReleaseInterview,
};
